import { Component } from '@angular/core';

@Component({
  selector: 'app-profession-not-listed-popup',
  templateUrl: './profession-not-listed-popup.component.html'
})
export class ProfessionNotListedPopupComponent {
  constructor() {}
}
